import { Component } from "react";

/**
 * Catches React render errors anywhere in the tree and shows a friendly
 * fallback instead of a blank page. Avoids the "blank screen of doom" when
 * an API returns an unexpected shape or a component bug slips through.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface for debugging in DevTools console
    // eslint-disable-next-line no-console
    console.error("[CJ] render error:", error, info);
  }

  reset = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };

  refresh = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--tc-bg-soft)] p-6">
        <div className="max-w-md w-full tc-card p-8 text-center">
          <div className="text-5xl mb-3">🧡</div>
          <h1 className="font-display text-2xl text-tc-ink">Hang tight, CJ tripped on a wire.</h1>
          <p className="text-slate-500 text-sm mt-2 leading-relaxed">
            Something on this page didn't load right. Try a refresh, or head back to the Hub.
          </p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={this.refresh}
              data-testid="error-boundary-refresh"
              className="h-11 px-5 rounded-xl bg-[#f68b1f] text-white font-extrabold text-sm shadow-md hover:-translate-y-0.5 transition-all"
            >
              Refresh this page
            </button>
            <button
              onClick={this.reset}
              data-testid="error-boundary-home"
              className="h-11 px-5 rounded-xl border-2 border-slate-200 text-slate-700 font-bold text-sm hover:bg-slate-50"
            >
              Back to Hub
            </button>
          </div>
        </div>
      </div>
    );
  }
}
